import { styled } from '../theme';

const TableHeaderCell = styled('th')(({ theme }) => ({
    display: 'table-cell',
    padding: '10px 20px 0 30px',
    textAlign: 'left',
    verticalAlign: 'inherit',
    borderBottom: theme.border.tableRowSeparator,
    fontSize: '1.4rem',
    fontWeight: theme.typography.fontWeight.bold,
}));

export default TableHeaderCell;
